import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { DisplayBox, Loading } from "../components";
import { AffiliateSettingInterface, ApiHelper, FeedInterface } from "../helpers";
import { FeedStats } from "./components";

interface Props {

}


export const FeedsAdminPage: React.FC<Props> = props => {
  const [feeds, setFeeds] = React.useState<FeedInterface[]>(null);
  const [statsFeed, setStatsFeed] = React.useState<FeedInterface>(null);
  const [affiliateSetting, setAffiliateSetting] = React.useState<AffiliateSettingInterface>(null);
  const [subscribers, setSubscribers] = React.useState<{ name: string, amount: number }[]>(null);

  const init = async () => {
    ApiHelper.get<FeedInterface[]>("/feeds").then((data) => setFeeds(data || []));
    const data = await ApiHelper.get<AffiliateSettingInterface[]>("/affiliateSettings");
    if ((data || []).length > 0) {
      setAffiliateSetting(data[0]);
      ApiHelper.get<{ name: string; amount: number }[]>("/affiliateSettings/subscribers").then(d => setSubscribers(d || []));
    }
  }

  React.useEffect(() => { init() }, [])


  const getTable = () => {
    if (feeds === null) return <Loading />
    else {
      if (feeds.length === 0) return <p>You do not have any feeds yet</p>
      else {
        const rows: React.ReactElement[] = [];
        feeds.forEach(f => {
          const feed = f;
          rows.push(<tr>
            <td><Link to={"/settings/feedAdmin/" + f.id}>{f.name}</Link></td>
            <td><a href="about:blank" onClick={(e) => { e.preventDefault(); setStatsFeed(feed); }}>Stats</a></td>
          </tr>)
        });
        return (<table className="table table-sm table-striped">
          <thead>
            <tr><th>Name</th><th>Stats</th></tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>)
      }
    }
  }

  const getNewButton = () => {
    return <Link to={"/settings/feedAdmin/0"} className="btn btn-sm btn-success"><i className="fas fa-plus" style={{ color: "#FFF" }}></i> New</Link>
  }

  const getStats = () => {
    if (statsFeed) return (<FeedStats feed={statsFeed} />)
  }


  const getSubscribers = () => {
    if (!subscribers) return <Loading />
    else if (subscribers.length === 0) return <p>You do not have any subscribers  yet.</p>
    else {
      const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
      const rows: React.ReactElement[] = [];
      subscribers.forEach(a => {
        rows.push(<tr>
          <td>{a.name}</td>
          <td>{formatter.format(a.amount)}</td>
          <td>{formatter.format(a.amount * affiliateSetting.ownedFeedCommission / 100)}</td>
        </tr>);
      });

      return (<table className="table table-sm table-striped" >
        <thead>
          <tr>
            <th>Name</th>
            <th>Monthly Charges</th>
            <th>Expected Commission</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>);
    }
  }

  return (
    <>
      <h1><i className="fas fa-satellite-dish"></i> Feed Admin</h1>
      <Row>
        <Col lg={6}>
          <DisplayBox headerText="Feeds" headerIcon="fas fa-satellite-dish" editContent={getNewButton()} >
            {getTable()}
          </DisplayBox>
          <DisplayBox headerIcon="fas fa-money-bill-wave" headerText="Subscribers">
            {getSubscribers()}
          </DisplayBox>
        </Col>
        <Col lg={6}>
          {getStats()}

        </Col>
      </Row>
    </>
  );
};